// extracted by mini-css-extract-plugin
export default {"button":"Ek-z","reviewSort":"Fk-z"};